"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.evaluateFromXlsx = void 0;
const edit_1 = __importDefault(require("@sheet/edit"));
const lodash_1 = __importDefault(require("lodash"));
const common_1 = require("@finley-technologies/common");
/**
 * Evaluation function requires a source and a config in order to parse
 *
 * Input:
 *  - xlsxBuffer: file buffer from excel file
 *  - config: Covenant configuration, initially from credit agreement
 *
 * Output: TODO extend this based on desired output parameters
 *  - array of boolean values to capture pass/fail state of covenant
 *
 */
const retrieve = (fileBuffer) => {
    // TODO - optimize by only reading required sheets
    const workbook = edit_1.default.read(fileBuffer, {
        type: 'buffer',
        template: true,
        cellStyles: true,
        cellDates: true,
    });
    const sheets = {};
    const getCovenantValue = (source) => {
        var _a;
        const { sheet, cell } = source;
        // Caching the worksheet in case this sheet access is an expensive operation
        let worksheet = sheets[sheet];
        if (worksheet === undefined) {
            worksheet = workbook.Sheets[sheet];
            (0, common_1.finleyAssert)(worksheet, new common_1.error.FinleyError(`Invalid sheet name for XLSX workbook in getCovenantValue using sheetName: ${sheet}`, { logLevel: common_1.error.LogLevel.Warn }));
            sheets[sheet] = worksheet;
        }
        (0, common_1.finleyAssert)((_a = worksheet[cell]) === null || _a === void 0 ? void 0 : _a.v, new common_1.error.FinleyError(`Invalid cell referenced in XLSX sheet in getCovenantValue using cellName: ${cell}`, { logLevel: common_1.error.LogLevel.Warn }));
        return worksheet[cell].v;
    };
    const getReportingDate = (source) => {
        var _a;
        const { sheet, cell } = source;
        // Caching the worksheet in case this sheet access is an expensive operation
        let worksheet = sheets[sheet];
        if (worksheet === undefined) {
            worksheet = workbook.Sheets[sheet];
            (0, common_1.finleyAssert)(worksheet, new common_1.error.FinleyError(`Invalid sheet name for XLSX workbook in getReportingDate using sheetName: ${sheet}`, { logLevel: common_1.error.LogLevel.Warn }));
            sheets[sheet] = worksheet;
        }
        (0, common_1.finleyAssert)((_a = worksheet[cell]) === null || _a === void 0 ? void 0 : _a.v, new common_1.error.FinleyError(`Invalid cell referenced in XLSX sheet in getReportingDate using cellName: ${cell}`, { logLevel: common_1.error.LogLevel.Warn }));
        const parsedDate = new Date(worksheet[cell].v);
        const convertedDate = common_1.date.strToFullDateStr(lodash_1.default.split(parsedDate.toISOString(), 'T')[0], 'yyyy-MM-dd');
        return convertedDate;
    };
    return {
        getCovenantValue,
        getReportingDate,
    };
};
const evaluate = (condition, value) => {
    const { limitValue, limitType } = condition;
    const validLimitTypes = ['min', 'max'];
    (0, common_1.finleyAssert)(lodash_1.default.includes(validLimitTypes, limitType), new common_1.error.FinleyError('Invalid limit type for financial covenant evaluation', { logLevel: common_1.error.LogLevel.Error }));
    if (limitType === 'min') {
        return value >= limitValue;
    }
    // We validate only min and max as options
    // If it's not min, then it has to be max
    // Default to max, avoid returning false
    return value <= limitValue;
};
const evaluateFromXlsx = ({ config, xlsxBuffer, }) => {
    const parsedData = retrieve(xlsxBuffer);
    try {
        return lodash_1.default.map(config, ({ key, conditions, location, reportingDateLocation }) => {
            const value = parsedData.getCovenantValue(location);
            const reportingDate = parsedData.getReportingDate(reportingDateLocation);
            const passed = lodash_1.default.every(conditions, (condition) => {
                return evaluate(condition, value);
            });
            return {
                reportingDate,
                key,
                value,
                passed,
            };
        });
    }
    catch (err) {
        if (common_1.typeguards.isFinleyErrorType(err)) {
            throw new common_1.error.FinleyError(err.message, {
                logLevel: err.logLevel,
                metadata: { logMeta: { config } },
            });
        }
        throw err;
    }
};
exports.evaluateFromXlsx = evaluateFromXlsx;
//# sourceMappingURL=index.js.map